/**
 * Cleans the input string from possible HTML
 * @param {String} input
 */
export function htmlSafeInput(input) {
    return input
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('\'', '&#39;')
        .replaceAll('"', '&quot;');
}
